import { createPortal } from "react-dom";

const DrawerPortal = ({ children }) => {
  const drawerRoot = document.getElementById("drawer-root");
  return createPortal(children, drawerRoot);
};

export default DrawerPortal;
